<template>
  <div class="details">
    <Header 
      @onChangeSetting="onChangeSetting" @onChangLogin="onChangLogin" :pageType="'details'" :setShow="['timeZone', 'order', 'oddsType', 'oddsForm']" 
      :tsz="svrTimestamp" :isLogin="loginShow" :myLeague="myLeague" :navTab="-1" @onLeagueFollowChange="onLeagueFollowChange"  
    />
    <div class="pageContent">
      <DetailsCrumbs  ref="DetailsCrumbs"  :league="league" :match="match" /> 
      <DetailsHead ref="DetailsHead" :match="match" :league="league" :myLeague="myLeague" @onLeagueFollowChange="onLeagueFollowChange" :class="(isHeadDown.isShow?'gameHead_fix_on':'')"/>
      <DetailsTab ref="Tab" :match="match" @onTabChange="onTabChange" :hasData="hasData"/>
      <div v-if="isLoading" style="padding: 20% 0;">
        <van-loading vertical><span class="loadtext">loading...</span></van-loading>
      </div>
      <div v-else>
        
        <WDL 
          :detailInfo="detailInfo" :relateMatch="relateMatch" :relateLeague="relateLeague" :match="match" :isLogin="isLogin"
          @changePup="changePup" @onChangLogin="onChangLogin" :setting="setting" v-if="tabData.childID == 1 && match != null"/>

        <AsianHandicap 
          :detailInfo="detailInfo" :relateMatch="relateMatch" :relateLeague="relateLeague" :match="match" :isLogin="isLogin" 
          @changePup="changePup" @onChangLogin="onChangLogin" :setting="setting" v-if="tabData.childID == 2 && match != null"/>
        
        <OverUnder 
          :detailInfo="detailInfo" :relateMatch="relateMatch" :relateLeague="relateLeague" :match="match" :isLogin="isLogin" 
          @changePup="changePup" @onChangLogin="onChangLogin" :setting="setting" v-if="tabData.childID == 3 && match != null"/>

        <CorrectScores 
          :detailInfo="detailInfo" :relateMatch="relateMatch" :relateLeague="relateLeague" :match="match" :isLogin="isLogin" 
          @onChangLogin="onChangLogin" :setting="setting" v-if="tabData.childID == 4 && match != null"/>
        
        <Goals 
          :detailInfo="detailInfo" :relateMatch="relateMatch" :relateLeague="relateLeague" :match="match" :isLogin="isLogin" 
          @onChangLogin="onChangLogin" :setting="setting" v-if="tabData.childID == 5 && match != null"/>
      </div>
      <UpdataLog :divergenceLogList="divergenceLogList" :marginLogList="marginLogList" :type="updataType" :setting="setting" @changePup="changePup"/>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import Header from '@/components/header.vue';
import Footer from '@/components/footer.vue';
import DetailsCrumbs from '@/views/details/components/detailsCrumbs.vue';//顶部面包屑
import DetailsHead from '@/views/details/components/detailsHead.vue';//
import DetailsTab from '@/views/details/components/detailsTab.vue';//
// import Poisson from '@/views/details/components/poisson.vue';//
import Margin from '@/views/details/components/margin.vue';//
import Divergence from '@/views/details/components/divergence.vue';//


import WDL from '@/views/details/components/1x2.vue';//
import AsianHandicap from '@/views/details/components/asianHandicap.vue';//
import OverUnder from '@/views/details/components/overunder.vue';//
import CorrectScores from '@/views/details/components/correctScores.vue';//
import Goals from '@/views/details/components/goals.vue';//
import UpdataLog from '@/views/details/components/updataLog.vue';//

import { getMatchInfo, getPredictionDetail, getPredictionRelateMatch, getFootballUpdateLog, getUser,getSocket, getSocketUpdate } from '@/api/api';

export default {
  name: 'details',
  components: {
    Header,
    Footer,
    DetailsCrumbs,
    DetailsHead,
    DetailsTab,
    // Poisson,
    Margin,
    Divergence,

    WDL,
    AsianHandicap,
    OverUnder,
    CorrectScores,
    Goals,
    UpdataLog
  },
  data(){
    return{
      league:null,//赛事
      match:null,//比赛基础信息
      matchId: this.$route.params.id,
      state:-1,//比赛状态
      detailInfo: null,
      relateMatch: [], //关联比赛
      relateLeague: [], //关联联赛

      baseParam: { 
        userToken: '',
        langNumber: 3,//语言标识(公共参。1=简 2=繁 3=英 4=韩 5=泰 6=越 7=日本).
        platform: 4,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
        appVersion:'eg.3.25.0',//版本号(公共参。eg.3.25.0).
        portType: 1,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
        sportType: 1,//1足球2篮球(非公共参)
      },

      tabData: {
        childID: this.common.getTabChildId(this),
        name: '1x2',
        tabId: 5
      },
      divergenceLogList: null,
      marginLogList: null,
      isHeadDown:{
        isShow:false,//头部伸缩
      },

      isLogin: false,//判断是否登录
      
      loginShow: false, // 是否显示登录弹窗
      svrTimestamp: 0, // 系统时间
      setting: {
        oddsFormRadio: 1,
        tsz: '+08:00'
      },
      myLeague: {},
      timeZone: '+08:00',
      version: 0, // 数据版本号
      tabSave:{  
        '1-1':{
          name:'Summary',
          oneShow:false,
          tabShow:false,
          isData:false,
          isRead:0,
        },
        '1-2':{
          name:'Stats',
          oneShow:false,
          tabShow:false,
          isData:false,
          isRead:0,
        },
        '1-3':{
          name:'LineUps',
          oneShow:false,
          tabShow:false,
          isData:false,
          isRead:0,
        },
        '1-4':{
          name:'Event',
          oneShow:false,
          tabShow:false,
          isData:false,
          isRead:0,
        },
        '2-0':{
          name:'Odds',
          oneShow:false,
          tabShow:false,
          isData:false,
          isRead:0,
        },
        '3-0':{
          name:'H2H',
          oneShow:false,
          tabShow:false,
          isData:false,
          isRead:0,
        },
        '4-0':{
          name:'Standings',
          oneShow:false,
          tabShow:false,
          isData:false,
          isRead:0,
        },
        '5-0':{
          name:'Prediction',
          oneShow:false,
          tabShow:true,
          isData:true,
          isRead:0,
        }
      },

      isLoading: true,

      updataType: '',

      hasData: {
        hasMargin: true,
        hasPoisson: true,
        hasDiff: true,
      }
    }
  },
  methods:{
    //基础信息读取
    async matchInfoData(){
      var _userInfo = '';
      if(typeof window!='undefined'){
        _userInfo=this.common.getCookie('userInfo')||'{}';
        _userInfo = JSON.parse(_userInfo)
      }
      var _this=this;
      // let param = Object.assign( this.baseParam,obj);
      let obj = {
        // matchId: 4776127,   //完场
        // matchId: 4712525,   //异常
        // matchId: 4777128,   //未开始
        
        // matchId: 4798687,   //点球获胜
        // matchId: 4306024,  //加时
        // matchId: 4622403  //加时,点球
        // matchId: 4661446  //进行中
        matchId: this.matchId,
        userToken:_userInfo.token,
        // userToken:'470ae4ec3ecf51263034301c7e1f4b5a7750aa88',
      }
      let param = Object.assign( this.baseParam,obj);

      let tabSave=JSON.parse(JSON.stringify(this.tabSave));
      var state=JSON.parse(JSON.stringify(this.state))*1;
      
      await getMatchInfo(param).then((res) => {
        let data=JSON.parse(JSON.stringify(res.data));
        let res1=JSON.parse(JSON.stringify(res));
        data.match.serverTimestamp= data.serverTimestamp;//系统时间
        data.match.hasStanding= data.league.hasStanding||false;//积分版
        this.svrTimestamp = data.serverTimestamp;
        _this.league=data.league;//联赛赋值
        _this.match = data.match
        _this.state=data.match.state;
        //比赛状态：1上半场 2中场休息 3下半场 4完场 5中断 6取消 8加时 11点球 13延期 14腰斩 15待定 17未开赛
        //TAB判断
        let hasLineup=data.match.hasLineup||false;//是否有阵容 0非1=正式2=预测
        let hasStats=data.match.hasStats||false;//是否有统计 0非1是
        let hasEventLive=data.match.hasEventLive||false;//是否有事件直播 0非1是
        let hasLuck=data.match.hasLuck||false;//是否有指数
        let hasPrediction=data.match.hasPrediction||false;//是否有情报
        let hasStanding=data.match.hasStanding||false;//积分版
        //console.log('阵容',hasLineup,'Stats统计',hasStats,'直播',hasEventLive,'指数',hasLuck,'积分',hasStanding,'情报',hasPrediction);
        tabSave['1-2'].isData=hasStats;//统计
        tabSave['1-3'].isData=hasLineup;//阵容
        tabSave['1-4'].isData=hasEventLive;//事件直播
        tabSave['2-0'].isData=hasLuck;//事件直播
        tabSave['4-0'].isData=hasStanding;//积分版
        tabSave['5-0'].isData=hasPrediction;//情报
        this.tabSave=tabSave;

        this.predictionRelateMatchList(data.league.id);
        document.title = data.match.homeTeam.shortName + ' VS ' + data.match.awayTeam.shortName + this.SEO.title;

        
        if(state==-1&&[1,2,3,8,11,13,17].indexOf(data.match.state*1)>-1){
          _this.getSocketRenewal(false);
        }
      })
    },

    async predictionInfo(){
      var _userInfo = '';
      if(typeof window!='undefined'){
        _userInfo=this.common.getCookie('userInfo')||'{}';
        _userInfo = JSON.parse(_userInfo)
      }
      let obj = {
        userToken:_userInfo.token,
        // userToken:'470ae4ec3ecf51263034301c7e1f4b5a7750aa88',
        matchId: this.matchId,
        mType: this.tabData.childID,
        // matchId: 4718786,   //完场
        // matchId: 4712525,   //异常
        // matchId: 4777128,   //未开始
        
        // matchId: 4798687,   //点球获胜
        // matchId: 4306024,  //加时
        // matchId: 4622403  //加时,点球
        // matchId: 4661446  //进行中
        
        
      }
      let param = Object.assign( this.baseParam,obj);
      await getPredictionDetail(param).then((res) => {
        this.isLoading = false
        if(JSON.stringify(res.data) != '{}'){
          this.detailInfo = res.data
          this.hasData = {
            hasMargin: res.data.hasMargin,
            hasPoisson: res.data.hasPoisson,
            hasDiff: res.data.hasDiff,
          }
        }
      })
    },
    
    async predictionRelateMatchList(leagueId){
      var _userInfo = '';
      if(typeof window!='undefined'){
        _userInfo=this.common.getCookie('userInfo')||'{}';//
        _userInfo = JSON.parse(_userInfo)
      }
      let obj = {
        userToken:_userInfo.token,
        // userToken:'470ae4ec3ecf51263034301c7e1f4b5a7750aa88',
        leagueId: leagueId,   //完场
        mType: this.tabData.childID,
        matchId: this.matchId,
      }
      let param = Object.assign( this.baseParam,obj);
      await getPredictionRelateMatch(param).then((res) => {
        this.relateMatch = res.data.relateMatch
        this.relateLeague = res.data.relateLeague
      })
    },

    async footballUpdateLog(mType){
      var _userInfo = '';
      if(typeof window!='undefined'){
        _userInfo=this.common.getCookie('userInfo')||'{}';//
        _userInfo = JSON.parse(_userInfo)
      }
      let obj = {
        userToken:_userInfo.token,
        // userToken:'470ae4ec3ecf51263034301c7e1f4b5a7750aa88',
        matchId: this.matchId,
        mType: mType,
      }
      let param = Object.assign( this.baseParam,obj);
      await getFootballUpdateLog(param).then((res) => {
        if(JSON.stringify(res.data) == '{}'){
          return
        }
        if(mType == 10){
          this.marginLogList = res.data.ModelLog.analyse.logList
        }else if(mType == 11){
          this.divergenceLogList = res.data.ModelLog
        }
      })
    },

    //获取比赛更新
    async getSocketRenewal(isRefresh){
      //比赛信息+概况
      var _this=this;
      let tabSave=JSON.parse(JSON.stringify(this.tabSave));
      let tabData=JSON.parse(JSON.stringify(this.tabData));
      let match=JSON.parse(JSON.stringify(this.match));
      let matchId=JSON.parse(JSON.stringify(this.matchId));
      
      if(!match||!([1,2,3,8,11,13,17].indexOf(match.state*1)>-1)){
        return;
      }
      
      // console.log('getSocketUpdate','打开',tabSave,isRefresh);

      
      let param = {
        type:111,
        matchId:matchId
      } 
      await getSocket(this,param)

      await this.$socket.registerCallBack('FootballMatchDetailUpdate', function(res){
        var resData=getSocketUpdate(res,'FootballMatchDetailUpdate');
        resData=JSON.parse(JSON.stringify(resData));
        _this.socketData(1,resData)
      });
      
      await this.$socket.registerCallBack('FootballListReconnect', async()=>{
        _this.matchInfoData();
        // tabSave[tabData.tabId+''+'-'+''+tabData.childID].isRead=new Date().getTime();
        _this.getSocketRenewal('-1');
      });
    
      this.tabSave=tabSave;
      
    },
    //比赛基础信息 socket数据更新
    socketData(type,data){
      const _this=this;
      let match=JSON.parse(JSON.stringify(this.match))|| {};
      let matchId=JSON.parse(JSON.stringify(this.matchId));
      let state=JSON.parse(JSON.stringify(this.state));
      //console.log('match',match);
      //console.log('matchId',matchId);
      //console.log('socketD323a',data.updateMatch);
      //console.log('match',JSON.stringify(this.match));
      
      if(type==1&&data.matchId*1==matchId*1){//基础数据
        let _match = this.common.mergeObjects(match,data.updateMatch);
        this.match=_match;
        if(state!=-1&&state!=_match.state){
          _this.matchInfoData();
        }
      }else if(type==2&&data.matchId*1==matchId*1){//事件
        //console.log('socketData2',data);
        this.socketKeyList=data.keyList;
      }else if(type==3&&data.matchId*1==matchId*1){//指数
        //console.log('socketData3',data);
        // asian:{companyId: '3000181', hand: '-0.5', home: '0.82', away: '0.97'}
        // matchId: "4634718"
      }
    },

    
    //TAB回调
    onTabChange(e){
      this.detailInfo = null
      this.tabData = e
      if(e.childID == 1){
        this.footballUpdateLog(10);
        this.footballUpdateLog(11);
      }else if(e.childID == 2 || e.childID == 3){
        this.footballUpdateLog(11);
      }
      if(this.$route.path.indexOf("/details/" + this.common.getTabChildName(e.childID) + '/' + this.$route.params.id) != -1)  return
      let _homeName = this.common.formalTitle(this.match.homeTeam.fullName)
      let _awayName = this.common.formalTitle(this.match.awayTeam.fullName)
      this.$router.push("/details/" + this.common.getTabChildName(e.childID) + '/' + this.$route.params.id + '/' + _homeName + '-vs-' + _awayName);
    },
    
    changePup(e){
      this.updataType = e
    },
    

    init(){
      let _setting = this.common.getCookie('setting');

      if(typeof(_setting) != 'undefined' && _setting != null){
        //alert('设置信息')
        //alert(JSON.stringify(_setting))
        _setting = JSON.parse(_setting);
        this.setting.oddsFormRadio = _setting.oddsFormRadio*1;
        this.timeZone = _setting.tsz;
        
      }
      
      this.matchInfoData();

      this.getFavLeagues();
      this.getUserInfo()
      
      this.predictionInfo();
      if(this.tabData.childID == 1){
        this.footballUpdateLog(10);
        this.footballUpdateLog(11);
      }else if(this.tabData.childID == 2 || this.tabData.childID == 3){
        this.footballUpdateLog(11);
      }

      this.handleScroll();
    },

    //获取滚动条高度
    handleScroll() {
      if(typeof window!='undefined'){
        let isHeadDown=JSON.parse(JSON.stringify(this.isHeadDown));
        let DetailsHead= (this.$refs.DetailsHead?this.$refs.DetailsHead.$el.clientHeight*1:null);
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        if(!DetailsHead){
          return;
        }
        isHeadDown.isShow = scrollTop >= DetailsHead ? true : false
        this.isHeadDown=isHeadDown;
      }
    },

    // 判断是否登录
    async getUserInfo(){
      let param = {
        userToken: '',
        // userToken:'470ae4ec3ecf51263034301c7e1f4b5a7750aa88',
      }
      let _userInfo = this.common.getCookie('userInfo');
      if(typeof(_userInfo) != 'undefined' && _userInfo != null){
        _userInfo = JSON.parse(_userInfo);
        param.userToken = _userInfo.token;
      }
      await getUser(param).then((res) => {
        let _res = res;
        if(_res.state == 200 || this.common.isFirstVisit() == true){
          this.isLogin = true
        }
      }).catch((res) => {
      })
    },

    // 设置回调参数操作
    onChangeSetting(e){
      console.log('设置回调参数操作', e)
      let _setting = e;
      
      let _oddsForm = this.common.jsonParse(this.setting.oddsFormRadio)*1;
      let _tsz = JSON.parse(JSON.stringify(this.timeZone));


      if(_oddsForm != _setting.oddsFormRadio*1){ //赔率格式
        this.setting.oddsFormRadio = _setting.oddsFormRadio*1;
        if(this.tabData.childID == 10 && this.isLogin == true){
          this.$refs.marginRef.getLineInfo()
        }
        return;
      }

      if(_tsz != _setting.tsz){ //时区
        this.setting['tsz'] = this.timeZone = _setting.tsz;
        if(this.tabData.childID == 10 && this.isLogin == true){
          this.$refs.marginRef.getLineInfo()
        }
        this.predictionInfo();
        this.matchInfoData();
      }
    },

    // 登录弹窗回调
    onChangLogin(val){
      let _val = val;
      this.loginShow = _val.loginShow;
    },

    // 关注赛事变化回调
    onLeagueFollowChange(val){
      if(val){
        this.myLeague = val;
      }
    },

    
    // 获取关注联赛
    getFavLeagues(){
      let _myLeague = this.common.getStorage('leagueListFollow');
      if(_myLeague != null){
        this.myLeague = JSON.parse(_myLeague);
      }
    },
  },
  created(){
    this.init();
  },

  computed: {
      ...mapState('details', ['SEO']),
  },
  mounted(){
    if(typeof window!='undefined'){
      window.addEventListener('scroll', this.handleScroll);
    }
    
  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听器/屏幕宽度事件监听器
    if(typeof window!='undefined'){
      window.removeEventListener('scroll', this.handleScroll);
    }
    // 在组件销毁前关闭WebSocket连接
    this.$socket.unRegisterCallBack('FootballMatchDetailUpdate');
    this.$socket.unRegisterCallBack('FootballMatchDetailGoalUpdate');
    this.$socket.unRegisterCallBack('FootballMatchDetailLuckUpdate');
    this.$socket.unRegisterCallBack('FootballMatchStatsUpdate');
    this.$socket.unRegisterCallBack('FootballMatchEventUpdate');
    this.$socket.unRegisterCallBack('FootballMatchStandingUpdate');
    this.$socket.unRegisterCallBack('FootballMatchLuckUpdate');
  },
  watch:{
    tabData(){
      this.predictionInfo();
    },
  }
}
</script>
<style lang="less">
.details{
  background: @color_F5F5F5;
  font-family: @font_family_PublicSans_Regular;
  .pageContent{
    min-height: 90vh;
    width: 1376px;
    margin: 0 auto;
  }
  
}
.marginIcon{
    width: 25px!important;
    height: 25px!important;
    background: url('~@/assets/images/marginIcon.svg') no-repeat;
    margin-right: 5px;
}
.divergenceIcon{
    width: 25px!important;
    height: 25px!important;
    background: url('~@/assets/images/divergenceIcon.svg') no-repeat;
    margin-right: 5px;
}
.poissonIcon{
    width: 25px!important;
    height: 25px!important;
    background: url('~@/assets/images/poissonIcon.svg') no-repeat;
    margin-right: 5px;
}
@media screen and (max-width: 767px) {
  .details{
    background: @color_FFF;
    .pageContent{
      width: 100vw;
      background: @color_FFF;
    }
  }
  .marginIcon{
      width: .18rem;
      height: .18rem;
      margin-right: .05rem;
  }
  .divergenceIcon{
      width: .18rem;
      height: .18rem;
      margin-right: .05rem;
  }
  .poissonIcon{
      width: .18rem;
      height: .18rem;
      margin-right: .05rem;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/details/details.vue